export const fronttabs = {
  items: [
    {
      link: "/oferta/szukaj.xml?top=8&sort=3&dojazd=samolot&udog=80000002&udor=0&termin=2025-12-01&dni=150",
      linkb: "",
      nazwa: "Popularne",
      pozycja: "1",
      tytul: "Popularne",
      grafika: "zima-popularne",
      text: "Najpopularniejsze<br />wczasy na zimę 2025/2026",
      textcolor: "light",
      buttontext: "Przeglądaj oferty",
    },
    {
      link: "/oferta/szukaj.xml?top=8&sort=1&udog=80000002&udor=0&pobyt=6,8&termin=2026-12-01&dni=150",
      linkb: "/last-minute/oferty.xml?dojazd=samolot&pobyt=6,14",
      nazwa: "Zima",
      pozycja: "2",
      tytul: "Zima 2025/26",
      grafika: "zima",
      text: "Wczasy zimą<br />nie tylko na narty!",
      textcolor: "dark",
      buttontext: "Przeglądaj oferty",
    },
    {
      link: "/oferta/szukaj.xml?top=8&sort=3&dojazd=wlasny&udog=80000002&udor=0&termin=2025-12-01&dni=150",
      linkb: "/rodzaj-oferty/all-inclusive-wyspykanaryjskie.xml",
      nazwa: "Dojazd własny",
      pozycja: "3",
      tytul: "Dojazd własny",
      grafika: "zima-dojazd-wlasny",
      text: "Wypoczynek zimą<br />z dojazdem własnym",
      textcolor: "light",
      buttontext: "Przejdź do ofert",
    },
    {
      link: "/oferta/szukaj.xml?top=8&sort=1&udog=80000002&udor=0&pobyt=13,15&termin=2025-12-01&dni=150",
      linkb: "/last-minute/oferty.xml?dojazd=samolot&pobyt=6,14",
      nazwa: "Zima na 2-tygodnie",
      pozycja: "4",
      tytul: "Zima na 2-tygodnie",
      grafika: "zima-dwa-tygodnie",
      text: "Zimowy wypoczynek<br />na dwa tygodnie!",
      textcolor: "light",
      buttontext: "Przeglądaj oferty",
    },
  ],
};
